import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

type RunbooksStateType = {
  prompts: Record<string, string>;
  promptChanged: Record<string, boolean>;
};

const initialState: RunbooksStateType = {
  prompts: {},
  promptChanged: {}
};

const runbooksSlice = createSlice({
  name: "runbooks",
  initialState,
  reducers: {
    updatePrompt: (
      state,
      action: PayloadAction<{
        settingsKey: string;
        prompt: string;
      }>
    ) => {
      state.prompts[action.payload.settingsKey] = action.payload.prompt;
    },
    updatePromptChanged: (
      state,
      action: PayloadAction<{
        settingsKey: string;
        changed: boolean;
      }>
    ) => {
      state.promptChanged[action.payload.settingsKey] = action.payload.changed;
    }
  }
});

export const { updatePrompt, updatePromptChanged } = runbooksSlice.actions;

export default runbooksSlice.reducer;
